<app-window-title [closable]="true"
                  [color]="'warn'"
                  [title]="'Search for files'"
                  (closed)="dialogRef.close()"></app-window-title>
<mat-form-field class="full-width"
                color="warn"
                appearance="outline">
  <mat-label>
    Enter keywords
  </mat-label>
  <input #textSearch
         matInput
         (keyup.enter)="handleFilesSearch(textSearch.value)">
  <mat-hint>Enter a text to search</mat-hint>
</mat-form-field>
<p [ngClass]="'mat-body'">
  Search criterias:
</p>
<ul [ngClass]="'mat-body'">
  <li>
    By file name.
  </li>
  <li>
    By file extension. (e.g.
    <i>
      .jpg
    </i>
    )
  </li>
  <li>
    By file content. (e.g.
    <i>
      some text
    </i>
    )
  </li>
  <li>
    By date of file. (e.g.
    <i>
      12/12/2020
    </i>
    )
  </li>
</ul>
<button color="warn"
        mat-flat-button
        (click)="handleFilesSearch(textSearch.value)">
  SEARCH
</button>
